module.exports = __webpack_public_path__ + "img/poster.cb99897f.jpg";